export default __webpack_public_path__ + "static/media/bmzi8.67bef268.jpg";